@if( element ) {
<div [class.ltr]="layoutDirectionLtr()" [class.rtl]="!layoutDirectionLtr()">
  <!-- Display all suggestions -->
  @for( gloss of glossSuggestions | sortByVotes; track gloss.gloss_id ) {
    <app-gloss-selector-line [gloss]="gloss" [container]="element" (action)="processGlossAction($event)"></app-gloss-selector-line>
  }

  <div class="button-container" [class.ltr]="layoutDirectionLtr()" [class.rtl]="!layoutDirectionLtr()">
    <mat-icon (click)="addNewSimpleGloss()" matTooltip="Add simple gloss..." aria-label="Add simple gloss...">add</mat-icon>
    <mat-icon [matMenuTriggerFor]="menu" matTooltip="More gloss options..." aria-label="More gloss options...">more_horiz</mat-icon>
    @if(displayMatchingGlosses) {
      <mat-icon  
        matTooltip="Show related glosses" aria-label="Show related glosses"
        (click)="expandMatchingGlosses = !expandMatchingGlosses"
        [innerHTML]="expandMatchingGlosses ? 'expand_less' : 'expand_more' "></mat-icon>
    }
  </div>

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="addNewSimpleGloss()">Add simple gloss...</button>
    <button mat-menu-item (click)="addWordPlusMarkdownGloss()">Add simple gloss & note...</button>
    <button mat-menu-item (click)="addNewMarkdownGloss()">Add freeform gloss...</button>
    @if(!(element.hasEmptyGloss)) {
      <button mat-menu-item (click)="addEmptyGloss()">Add empty gloss</button>
    }
  </mat-menu>

  <!-- Maybe display glosses that don't match the voice of the word -->
  @if( displayMatchingGlosses && expandMatchingGlosses ) {
    <div class="nmg-container" [class.ltr]="layoutDirectionLtr()" [class.rtl]="!layoutDirectionLtr()">
      @for( voice of nonMatchingGlossSuggestions.keys(); track voice ) {
        <div class="voice-label">{{voice | voiceInEnglish}}</div>
        @for( gloss of nonMatchingGlossSuggestions.get(voice); track gloss.gloss_id ) {
          <div class="gloss" [innerHTML]="gloss.html" [appProjectTextStyle]="synchronizerService.currentProject" (dblclick)="nonMatchingDoubleClick(gloss)"></div>
        }
      }
    </div>
  }

</div>
}